import { initContactForm } from './contact';

document.addEventListener('DOMContentLoaded', () => {
  initContactForm({
    formId: 'contact-form',
    completeUrl: '/business/contact/complete/',
  });
});
